module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_vm._m(0), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "list-item1",
    staticStyle: {
      "margin-top": "1em!important"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/07_chapter1#ch1",
      "id": "ch1"
    }
  }, [_c('big', [_c('b', [_vm._v("1")])])], 1)]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/07_chapter1#ch1"
    }
  }, [_c('big', [_vm._v("Inception and Design")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('a', {
    attrs: {
      "href": "#/text/08_chapter2#ch2",
      "id": "ch2"
    }
  }, [_c('big', [_c('b', [_vm._v("2")])])], 1)]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/text/08_chapter2#ch2"
    }
  }, [_c('big', [_vm._v("Layout and Build")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/09_chapter3#ch3",
      "id": "ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('b', [_vm._v("3")])])], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/09_chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("Crews")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/10_chapter4#ch4",
      "id": "ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('b', [_vm._v("4")])])], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/10_chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("Parent Ships")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/11_chapter5#ch5",
      "id": "ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('b', [_vm._v("5")])])], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/11_chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("Techniques and Tactics")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/12_chapter6#ch6",
      "id": "ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('b', [_vm._v("6")])])], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/12_chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("The Army On Board")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/13_chapter7#ch7",
      "id": "ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('b', [_vm._v("7")])])], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/13_chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("Specialist Craft and Roles")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "list-item1"
  }, [_c('span', {
    staticClass: "label"
  }, [_c('span', {
    attrs: {
      "href": "#/text/14_chapter8#ch8",
      "id": "ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_c('b', [_vm._v("8")])])], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/14_chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("Operations")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "chap-title",
    staticStyle: {
      "font-size": "2.5em",
      "margin-top": "2em!important",
      "margin-bottom": "1em!important"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "paranoindent1",
    attrs: {
      "id": "intro"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/06_introduction#intro"
    }
  }, [_vm._v("Introduction")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "paranoindent1",
    attrs: {
      "id": "note"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/15_notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "paranoindent1",
    attrs: {
      "id": "source"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_sources#source",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "paranoindent1",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/17_index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7831c1cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/05_toc.vue
// module id = 66
// module chunks = 0